var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerGames parent row wrap grow v-end margin-top_base-phone"},_vm._l((_vm.games),function(game,index){return _c('lazy-image',{key:index,attrs:{"alt":game.name,"src":game.image,"title":game.name,"is-image-fill-container":false,"class-name":"footerGame parent centered width_auto","relative":""}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cb316ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterGames.vue
// module id = null
// module chunks = 